import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61a8cefe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-goods-item-box" }
const _hoisted_2 = { class: "order-goods-top-box" }
const _hoisted_3 = { class: "order-goods-image-box" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "send-status-box"
}
const _hoisted_6 = { class: "order-goods-text-box" }
const _hoisted_7 = {
  key: 0,
  class: "order-sku-box"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 2,
  style: {"margin-top":"4px"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "send-tag-box" }, "已发货", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "order-right-text-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", { src: _ctx.goodsImage }, null, 8, _hoisted_4),
        (_ctx.modelValue.packId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "已发货"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, _toDisplayString(_ctx.modelValue.name), 1),
        (_ctx.skuText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.skuText), 1))
          : _createCommentVNode("", true),
        (_ctx.modelValue.message && _ctx.modelValue.message.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_el_link, {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDialog(_ctx.modelValue.message)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查看留言")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.modelValue.packId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", null, "￥" + _toDisplayString(_ctx.modelValue.price), 1),
      _createElementVNode("div", null, _toDisplayString(_ctx.modelValue.num) + "件", 1)
    ])
  ]))
}